export class HealthError {
  constructor(
    public status: number = 500,
    public type: string = "",
    public title: string = "",
    public detail: string = "",
    public userMessage: string = "",
    public timestamp: string = "",
    public fields: FieldError[] = [],
  ) {}

  static fromJson(json: HealthError): HealthError {
    if (!json) return new HealthError();

    return new HealthError(
      json.status,
      json.type,
      json.title,
      json.detail,
      json.userMessage,
      json.timestamp,
      json.fields ? json.fields.map((e: FieldError) => FieldError.fromJson(e)) : [],
    );
  }
}

export class FieldError {
  constructor(
    public name: string,
    public userMessage: string,
  ) {
    this.name = name;
    this.userMessage = userMessage;
  }

  static fromJson(json: FieldError): FieldError {
    return new FieldError(json.name, json.userMessage);
  }
}
